import moment from 'moment'
/* 时间过滤器 - 日/月/年 */
export function formatDateEn(value) {
  return value ? moment(value).format('MMMM-DD-YYYY HH:mm:ss') : ''
}
export function formatDate(value) {
  return value ? moment(value).format('DD-MM-YYYY') : ''
}
export function formatDateTime(value) {
  return value ? moment(value).format('YYYY-MM-DD HH:mm:ss') : ''
}
export function applicationFormatDate(value) {
  return value ? moment(value).format('DD/MM/YYYY') : ''
}
export function applicationFormatDateTime(value) {
  return value ? moment(value).format('DD/MM/YYYY hh:mm a') : ''
}
export function formatTime(value) {
  return value ? moment(value).format('HH:mm:ss') : ''
}
export function fromNow(value) {
  return value ? moment(value).fromNow() : ''
}
export function emailStatus(v){
  return v===0?'Pendding':v===1?'Delivered':v===2?'Failed or Rejected':''
}
export function eventType(eventType) {
  switch (eventType) {
    case 0:
      return "FS1"
    case 1:
      return "FS2"
    case 2:
      return "DS4"
    case 3:
      return "DS5"
    case 4:
      return "MS2"
    case 5:
      return "MS3(IBDP)"
    case 6:
      return "FS1(Interim)"
    case 7:
      return "DS1"
    case 8:
      return "DS2"
    case 9:
      return "DS3"
    case 10:
      return "MS1"
    case 11:
      return "MS3(HKDSE)"
  }
}
export function operationType(value) {
  switch (value) {
    case 0:
      return "Edit Status"
    case 1:
      return "Confirm Information "
    case 2:
      return "Payment"
    case 3:
      return "Fill in information"
    case 4:
      return "Confirm Applicant Detail"
    case 5:
      return "Confirm Supporting Document"
    case 6:
      return "Confirm Payment Detail"
    case 7:
      return "Other Question"
    case 8:
      return "Subject Applied"
    case 9:
        return "Need Correct"
  }
}
export function levelApplyingFor(value) {
  switch (value) {
    case 0:
      return "FS1(小一P1)"
    case 1:
      return "FS2(小二P2)"
    case 2:
      return "DS1(小三P3)"
    case 3:
      return "DS2(小四P4)"
    case 4:
      return "拓階三 DS3 (小五至小六 P5-P6)"
    case 5:
      return "拓階四 DS4 (中一 S1)"
    case 6:
      return "拓階五 DS5 (中二 S2)"
    case 7:
      return "通階一 MS1 (中三 S3)"
    case 8:
      return "通階二 MS2 ( 中四 S4 )"
    case 9:
      return "通階三 MS3 ( 中五 S5 ) HKDSE"
    case 10:
      return "通階三 MS3 ( 中五 S5 ) - IBDP"
    case 11:
      return "FS1(小一P1) Interim"
  }
}
export function applicationType(value) {
  switch (value) {
    case 0:
      return "FS1"
    case 1:
      return "FS2"
    case 2:
      return "DS4"
    case 3:
      return "DS5"
    case 4:
      return "MS2"
    case 5:
      return "MS3(IBDP)"
    case 6:
      return "FS1(Interim)"
    case 7:
      return "DS1"
    case 8:
      return "DS2"
    case 9:
      return "DS3"
    case 10:
      return "MS1"
    case 11:
      return "MS3(HKDSE)"
  }
}
export function providedOfferReplyType(value) {
  switch (value) {
    case 0:
      return "Waiting for reply"
    case 1:
      return "Offer accepted"
    case 2:
      return "Offer rejected"
    case 3:
      return "Offer expired"
  }
}
export function identity(value) {
  switch (value) {
    case 0:
      return "父親 Father"
    case 1:
      return "母親 Mother"
    case 2:
      return "監護人 Guardian"
  }
}
export function applicationStatus(value) {
  switch (value) {
    case 0:
      return "Open"
    case 1:
      return "Completed without payment "
    case 2:
      return "Paid "
    case 3:
      return "Pending for amendment"
    case 4:
      return "Re-submitted"
    case 5:
      return "Confirmed"
    case 6:
      return "Interview-1"
    case 7:
      return "Waiting List 1"
    case 8:
      return "Interview-2"
    case 9:
      return "Waiting List 2"
    case 10:
      return "Offered"
    case 11:
      return "No offer"
    case 12:
      return "Offer accepted"
    case 13:
      return "Offer rejected"
    case 14:
      return "Offer expired"
  }
}
export function applicationStage(value) {
  switch (value) {
    case 0:
      return "(S0) Not Filling form yet"
    case 1:
      return "(S1) Filling form "
    case 2:
      return "(S3) Finish filling form "
    case 3:
      return "(S5) Finish upload file"
    case 4:
      return "(S6) Need correct the form information"
    case 5:
      return "(S7) Submitted the correction form"
    case 6:
      return "(S8) Form submitted (payment not settle) "
    case 7:
      return "(S9) Form submitted (payment ready)"
    case 8:
      return "(S10) Complete the review information"
    case 9:
      return "(S11) Arranged Interview-1"
    case 10:
      return "(S11A) Waiting List (1st round)"
    case 11:
      return "(S12) Arranged Interview-2"
    case 12:
      return "(S12A) Waiting List (2nd round)"
    case 13:
      return "(S13) Provide Offered"
    case 14:
      return "(S14) No Offered"
    case 15:
      return "(S15) Accepted Offer"
    case 16:
      return "(S16) Rejected Offer"
    case 17:
      return "(S17) No reply"
  }
}
export function accountStatus(value){
  return  value ? 'Inactive' : 'Active'
}

///html标签替换
export function richText(value){
  return  value !==''? value.replace(/<.+?>/g, ''): '';
}

///判断输入值是否为正整数
export function isPositiveInteger(s){
  if((/(^[1-9]\d*$)/.test(s))) {
     return `+${s}`
  } else {
    return s
  }
}   

//// 全字母大写
export function toUpperCase(value) {
   return   value.slice(0,1).toUpperCase() +value.slice(1).toLowerCase(); 
}
//// 全字母大写
export function replace(value) {
   return value !==''? value.replace(/zh/g,''): ''
}

export function setSex(value){
   return value==0 ? 'Male' : 'Female'
}
export function paymentMethod(value){
   return value==0 ? 'Paypal' : 'Receipt'
}
export function paymentStatus(value){
   return value !==null ? 'Paid' : ''
}
///设置绝对值
export function abs(value){
   return Math.abs(value); 
}

export function ellipsis(value){
  if (!value) return '';
  if (value.length > 100) {
    return value.slice(0,100) + '...'
  }
  return value
}

export function toFixed(value){
  return value.toFixed(1)
}